module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Cap-2-f2a0fbef6abd385d96a91a78b51ace28.svg";